export { default as BOTSearchTiresBySizePanel } from '../BOTSearchTiresBySizePanel'
